import React from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { asPercentageString, asPercentageStringDecimal } from "../../utils/formatters";
import AnimatedNumber from "react-animated-number";
import { Tooltip } from "react-tooltip";
import { useLightTheme } from "../../hooks/useLightTheme";

function PercentageDisplay(props) {
  const lightTheme = useLightTheme();

  props = {
    size: 46,
    showDecimal: false,
    disableAnimation: false,
    color: "#4a9bff",
    toFixedValue: null,
    toolTipId: "percentageDisplay",
    ...props
  };
  const style = {
    margin: 0,
    padding: 0,
    display: "inline",
    fontWeight: "100",
    transition: "0.8s ease-out",
    fontSize: props.size,
    color: lightTheme ? "#1c64f2" : props.color
  };

  const formatValue = (n) =>
    props.showDecimal
      ? asPercentageStringDecimal(n, props.toFixedValue)
      : asPercentageString(n, props.value);
  const animatedProps = {
    component: "h5",
    value: +props.value || 0,
    initialValue: props.disableAnimation ? +props.value : 0,
    style,
    className: "moneyDisplay",
    duration: 1000,
    stepPrecision: 0,
    formatValue
  };
  return (
    <span
      data-tooltip-html={props.toolTipContent}
      data-tooltip-id={props.toolTipId}
      style={{ display: "inline-block" }}
    >
      {props.url ? (
        <a style={styles.cta} href={props.url} target="_raw_data_tab">
          <span>
            <AnimatedNumber {...animatedProps} />
          </span>
        </a>
      ) : (
        <AnimatedNumber {...animatedProps} />
      )}
      <Tooltip id={props.toolTipId} float />
    </span>
  );
}

PercentageDisplay.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.number,
  color: PropTypes.string,
  url: PropTypes.string,
  showDecimal: PropTypes.bool,
  toFixedValue: PropTypes.number,
  toolTipContent: PropTypes.string,
  toolTipId: PropTypes.string,
  disableAnimation: PropTypes.bool
};

let styles = {
  cta: {
    textDecoration: "none"
  }
};

export default Radium(PercentageDisplay);
